import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#202020",
      d: "M3 4.5h8V3H3zM3 11h6V9.5H3zm0-3.25h8v-1.5H3zM1.5 14q-.62 0-1.06-.44A1.45 1.45 0 0 1 0 12.5v-11Q0 .88.44.44T1.5 0h11q.619 0 1.06.44.44.442.44 1.06v11q0 .619-.44 1.06-.442.44-1.06.44zm0-1.5h11v-11h-11z"
    }, null, -1)
  ]))]))
}
export default { render: render }